<template>
    <div class="taskboard-wrapper d-flex flex-column">
        <!-- Barra di ricerca -->
        <v-toolbar flat dense class="background-1">
			<div class=" d-flex">
				<v-icon>mdi-calendar-check-outline</v-icon>
				<div class="ml-2 font-weight-medium subtitle-1">{{ entityTitle }}</div>
			</div>
			<v-spacer></v-spacer>

			<!-- Toggle Vista -->
			<v-btn-toggle v-model="viewMode" mandatory dense class="mr-3">
				<v-btn small value="tasklist" title="Vista Tasklist">
					<v-icon small>mdi-view-list</v-icon>
				</v-btn>
				<v-btn small value="kanban" title="Vista Kanban per stato">
					<v-icon small>mdi-view-column</v-icon>
				</v-btn>
			</v-btn-toggle>

			<!-- Selezione multipla -->
			<v-btn
				small
				:color="selectsMode ? 'primary' : ''"
				:dark="selectsMode"
				class="mr-3"
				title="Seleziona più task"
				@click="toggleSelectsMode"
			>
				<v-icon small>mdi-checkbox-multiple-outline</v-icon>
			</v-btn>

			<!-- Filtro Utente -->
			<v-autocomplete
				v-model="filterUserId"
				:items="usersFilter"
				item-text="text"
				item-value="value"
				label="Filtra per utente"
				dense
				outlined
				hide-details
				clearable
				style="max-width: 200px"
				class="mr-3 mt-0 pt-0 pb-1"
				@change="onUserFilterChange"
			></v-autocomplete>

            <v-text-field
                v-model="searchQuery"
                append-icon="search"
                label="Cerca Task..."
                single-line
                hide-details
				outlined
				dense
                clearable
                class="mt-0 pt-0 pb-1"
				style="max-width: 550px"
                @input="filterTasks"
            ></v-text-field>
            <v-spacer></v-spacer>
			<v-expand-transition>
				<v-chip
					v-show="filteredTasksCount !== null"
					:color="filteredTasksCount > 0 ? 'success' : 'warning'"
					text-color="white"
					small
					class="ml-3">
					<v-avatar left>
						<v-icon small>{{ filteredTasksCount > 0 ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
					</v-avatar>
					<strong>{{ filteredTasksCount }}</strong>
					<span class="ml-1">{{ filteredTasksCount === 1 ? 'task trovato' : 'task trovati' }}</span>
				</v-chip>
			</v-expand-transition>
        </v-toolbar>

        <div class="taskboard-content-wrapper">
            <div class="taskboard-content d-flex pb-6 pl-1">

				<!-- Vista Tasklist (default) -->
				<template v-if="viewMode === 'tasklist'">
					<div v-if="loading" class="d-flex align-center justify-center w100p py-8">
						<v-progress-circular indeterminate color="primary"></v-progress-circular>
						<span class="ml-3 grey--text">Caricamento...</span>
					</div>
					<draggable v-else
						:list="tasklists"
						:options="{
							group:'tasklist',
							animation: 350,
							ghostClass: 'taskboard-chosen-tasklist',
							chosenClass: 'taskboard-chosen-tasklist-class',
							delay: 150,
						}"
						:disabled="checkDisable"
						@start="drag = true"
						@end="onDrag($event, 'tasklists')" class="display-flex">

						<template v-for="(tasklist, t) in tasklists">
							<tasklist
								:tasklist="tasklist"
								:key="t"
								:show-dialog.sync="showDialog"
								:listable-type="listableType"
								:listable-id="listableId"
								:selects-mode.sync="selectsMode"
								@select-all="onGroupSelectAll"
							></tasklist>
						</template>
					</draggable>

					<add-tasklist v-if="!loading"
						:listable-type="listableType"
						:listable-id="listableId"
					></add-tasklist>
				</template>

				<!-- Vista Kanban per stato -->
				<template v-else-if="viewMode === 'kanban'">
					<div v-if="loadingKanban" class="d-flex align-center justify-center w100p py-8">
						<v-progress-circular indeterminate color="primary"></v-progress-circular>
						<span class="ml-3 grey--text">Caricamento...</span>
					</div>
					<template v-else>
						<taskboard-kanban-column
							v-for="column in kanbanColumns"
							:key="column.status"
							:column="column"
							:selects-mode="selectsMode"
							:tasklists="kanbanTasklists"
							@status-changed="onStatusChanged"
							@tasks-updated="onTasksUpdated"
							@task-added="onTaskAdded"
							@select-all="onGroupSelectAll"
						></taskboard-kanban-column>
					</template>
				</template>
            </div>						
			<v-speed-dial
				v-model="fab"
				fixed
				bottom
				right
				direction="left"
				transition="slide-y-reverse-transition"
				>
				<template v-slot:activator>
					<v-tooltip top>
						<template v-slot:activator="{ on: tooltip }">
							<v-btn
								v-on="{ ...tooltip }"
								v-model="fab"
								color="primary"
								dark
								fab
								>
								<v-icon v-if="fab">close</v-icon>
								<v-icon v-else>{{ taskShowed }}</v-icon>
							</v-btn>
						</template>
						<span>{{ taskShowed == 'dns' ? 'Tutti' : taskShowed == 'unarchive' ? 'Attivi' : 'Archiviati'  }}</span>
					</v-tooltip>
				</template>
			
			    <v-tooltip top>
					<template v-slot:activator="{ on: tooltip }">
						<v-btn
							@click="taskShowed = 'dns'"
							v-on="{ ...tooltip }"
							fab
							dark
							small
							color="green"
							>
							<v-icon>dns</v-icon>
						</v-btn>
                    </template>
					<span>Tutti</span>
				</v-tooltip>
			    <v-tooltip top>
					<template v-slot:activator="{ on: tooltip }">
						<v-btn
							@click="taskShowed = 'archive'"
							v-on="{ ...tooltip }"
							fab
							dark
							small
							color="orange"
							>
							<v-icon>archive</v-icon>
						</v-btn>
                    </template>
					<span>Archiviati</span>
				</v-tooltip>
			    <v-tooltip top>
					<template v-slot:activator="{ on: tooltip }">
						<v-btn
							@click="taskShowed = 'unarchive'"
							v-on="{ ...tooltip }"
							fab
							dark
							small
							color="indigo"
							>
							<v-icon>unarchive</v-icon>
						</v-btn>
                    </template>
					<span>Attivi</span>
				</v-tooltip>
    		</v-speed-dial>
        </div>

		<confirm-dialog
			:confirmModel="confirmExit"
			:mainTitle="$trans('save_primary_message')"
			:secondTitle="$trans('save_secondary_message')"
			@update:confirmModel="confirmExit = false"
            :exit="{label:'Esci', color:'error'}"
			:atConfirm="storeTask"
			:atExit="exit"
		></confirm-dialog>

		<confirm-dialog
			:confirmModel="confirmDelete"
			mainTitle="Elimina task"
			secondTitle="Sei sicuro di procedere con questa azione?"
			@update:confirmModel="confirmDelete = false"
			:atConfirm="deleteTask"
			:confirm="{label:'Procedi', color:'info'}"
		></confirm-dialog>

        <v-dialog v-model="showDialog" persistent :max-width="800" :fullscreen="fullScreen || $vuetify.breakpoint.smAndDown" style="overflow-x: hidden" scrollable>	        
            <v-card v-draggable :class="[$vuetify.breakpoint.smAndDown || fullScreen ? 'rounded-0' : 'round-card']">
                <v-card-title class="pa-3 background-1">
				    <p class="pl-2 pl-xl-3">{{ dialogTitle }}</p>
                    <v-spacer></v-spacer>

					<v-menu
						v-model="showButtonsList" 
						transition="slide-y-transition"
						content-class="round-card"
						:close-on-click="true"
						offset-y 
						min-width="200" 
						nudge-left="50">
						<template v-slot:activator="{ on }">
							<v-btn icon v-on="on">
								<v-icon>mdi-dots-vertical</v-icon>
							</v-btn>
						</template>

						<v-list dense>
							<v-subheader class="pt-2 fs12i" style="height:38px">Azioni</v-subheader>

							<v-list-item 
								v-if="model.id && $store.getters.checkModulePermissions('calendar')"
								@click="$router.push({name: 'calendar', params: { defaultInput: { eventable_type: 'task',	eventable_id: model.id, url: 'tasks' }}})"
								ripple>
								<v-list-item-icon>
									<v-icon style="font-size: 18px">mdi-calendar-today</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>Pianifica</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							
							<timecard-dialog v-if="model.id && $store.getters.checkModulePermissions('timecards')"
								:default-input="{entity: 'tasks_'+model.id}"
								button-component="v-list-item"
							></timecard-dialog>

							<v-list-item 
								v-if="model.id"
								@click="duplicate()"
								ripple>
								<v-list-item-icon>
									<v-icon style="font-size: 18px">mdi-content-copy</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>Duplica</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-menu>

    				<v-tooltip top v-if="$vuetify.breakpoint.mdAndUp">
						<template v-slot:activator="{ on: tooltip }">					
							<v-btn v-on="{ ...tooltip }" icon @click.native.stop="fullScreen = !fullScreen"><v-icon>fullscreen</v-icon></v-btn>
						</template>
						<span>Fullscreen</span>
    				</v-tooltip>
    				<v-tooltip top>
						<template v-slot:activator="{ on: tooltip }">					
							<v-btn v-on="{ ...tooltip }" icon @click.native.stop="closeDialog()"><v-icon>close</v-icon></v-btn>
						</template>
						<span>Chiudi</span>
    				</v-tooltip>

                </v-card-title>
				<v-divider></v-divider>
                <v-card-text style="overflow-x: hidden" class="pa-0 background-2 pt-4">
                    <v-container class="pa-2 pt-4" fluid>
                        <fields-generator
                            :fieldsset.sync="fieldsset"
                            :model="model"
                            ref="fieldsgenerator"
                        ></fields-generator>
                        <small class="pl-6">* Indica i campi obbligatori</small>
                    </v-container>

					<v-divider></v-divider>

					<products-task v-if="$store.getters.checkSettings('products_association_task') && showDialog"
						:model="model"
						ref="productstask"
						:company-id="companyId"
					></products-task>
					<v-divider v-if="$store.getters.checkSettings('products_association_task')"></v-divider>

					<checklist-task v-if="!$store.getters.checkSettings('hide_checklists_task')"
						:model="model"
					></checklist-task>

					<v-divider></v-divider>

					<activities v-if="model.id" class="pt-0"
						model-class="task"
						model-def="tasks"
						:model-id="model.id"
						dialog
					></activities>

					<v-col v-if="model.id" class="pt-0 px-0">
						<dms-uploader
							:id="model.id"
							attachable-type="task"
						></dms-uploader>
					</v-col>
                </v-card-text>
				<v-divider></v-divider>

                <v-card-actions class="pa-3 background-1">
                    <v-spacer></v-spacer>
					<v-tooltip bottom v-if="model.id">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" color="red" text @click.native="confirmDelete = true">Elimina</v-btn>
                        </template>
                        <span>Ctrl + Canc</span>
                    </v-tooltip>
					<v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" color="primary" text @click.native="closeDialog">Chiudi</v-btn>
                        </template>
                        <span>Esc</span>
                    </v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn v-bind="attrs" v-on="on" color="info" text :loading="loadingTask" @click.native="storeTask">Salva</v-btn>
						</template>
						<span>Ctrl + Invio</span>
					</v-tooltip>
                </v-card-actions>
            </v-card>
        </v-dialog>

	<v-bottom-navigation v-show="selectsMode" :active-class="''" color="grey">
		<v-btn :disabled="tasksSelected.length == 0" @click="deleteTasks">
			<span>Elimina</span>
			<v-icon>delete</v-icon>
		</v-btn>
		<v-btn :disabled="tasksSelected.length == 0" @click="archiveTasks">
			<span>Archivia</span>
			<v-icon>alarm</v-icon>
		</v-btn>
		<v-btn>
			<span>Selezionati</span>
			<span style="font-size: 24px">{{ tasksSelected.length }}</span>
		</v-btn>
		<v-btn @click="closeBottomMenu">
			<span>Chiudi</span>
			<v-icon>close</v-icon>
		</v-btn>
		</v-bottom-navigation>
    </div>
</template>

<script>

import Vue from 'vue'
import Draggable from 'vuedraggable'
import Tasklist from '@/components/common/Tasklist'
import Activities from '@/components/common/Activities'
import AddTasklist from '@/components/common/AddTasklist'
import ProductsTask from '@/components/common/ProductsTask'
import ChecklistTask from '@/components/common/ChecklistTask'
import TimecardDialog from '@/components/common/TimecardDialog'
import TaskboardKanbanColumn from '@/components/common/TaskboardKanbanColumn.vue'

export default {
	name: 'taskboard',
	components: {
		Tasklist,
		Draggable,
		Activities,
		AddTasklist,
		ProductsTask,
		ChecklistTask,
		TimecardDialog,
		TaskboardKanbanColumn
	},

	props: {
		listableType: {
			type: String,
			required: true
		},
		listableId: {
			type: Number,
			required: true
		},
		companyId: {
			type: Number,
			required: false
		},
		entityTitle: {
			type: String,
			required: false
		}
	},

	data() {
		return {
			model: {},
			fab: false,
			tasklists: [],
			tasklistsOriginal: [], // Copia originale per il ripristino
			infoData: null,
			defaultTask: {},
			tasksSelected: [],
			new_checklist: '',
			showDialog: false,
			fullScreen: false,
			selectsMode: false,
			loadingTask: false,
			confirmExit: false,
			confirmDelete: false,
			modelForWatcher: {},
			new_checklist_item: {},
			taskShowed: 'unarchive',
			showAddChecklist: false,
			fieldsset: { fields: [] },
			taskboardDef: {listable_type: this.listableType, listable_id: this.listableId},
			showButtonsList: false,
			query_task_opened: false,
			searchQuery: '', // Query di ricerca
			filteredTasksCount: null, // Contatore task filtrati
			// Kanban view
			viewMode: 'tasklist', // 'tasklist' | 'kanban'
			kanbanColumns: [],
			kanbanColumnsOriginal: [], // Copia originale per il ripristino dopo ricerca
			loadingKanban: false,
			filterUserId: null,
			usersFilter: [], // [{text, value}]
			kanbanTasklists: [], // [{text, value}] - tasklist disponibili per creare task
			loading: true,
		}
	},

	computed: {
		dialogTitle() {
			if(this.model.id) {
				return 'Modifica Task'
			} else {
				return 'Nuovo Task'
			}
		},

		filterStatus() {
			if(this.taskShowed == 'unarchive') {
				return 0
			} else if(this.taskShowed == 'archive') {
				return 1
			} else {
				return -1
			}
		},

		checkDisable() {
			return this.$vuetify.breakpoint.smAndDown ? true : false
		},
	},

	watch: {
		taskShowed() {
			// il filtro di ricerca viene riapplicato dentro le callback di caricamento
			if (this.viewMode === 'tasklist') {
				this.initializeTaskboard()
			} else {
				this.loadKanbanData()
			}
		},

		viewMode(newVal) {
			if (newVal === 'kanban') {
				this.loadKanbanData()
			} else {
				this.initializeTaskboard()
			}
		},
	},

	destroyed() {
		// remove event listeners
		document.removeEventListener('keydown', this.handleShortcut)
	},

	methods: {
		handleShortcut(e) {
			if (this.showDialog) {
				// catch ctrl + Enter when new dialog is opened and save
				if (e.ctrlKey && e.keyCode == 13) {
					this.storeTask()
				}

				// catch esc when new dialog is opened and close
				if (e.keyCode == 27) {
					this.closeDialog()
				}

				// catch cancel when new dialog is opened and close
				if (e.ctrlKey && e.keyCode == 46) {
					this.confirmDelete = true
				}
			}
		},
		
		exit() {
			this.confirmExit = false
			this.modelForWatcher = _.cloneDeep(this.model)
			this.closeDialog()
		},

		closeBottomMenu() {
			this.exitSelectsMode()
		},

		toggleSelectsMode() {
			if (this.selectsMode) {
				this.exitSelectsMode()
			} else {
				this.selectsMode = true
			}
		},

		exitSelectsMode() {
			this.selectsMode = false
			this.tasksSelected = []
			// Reset dei flag di selezione su tutte le strutture dati (viste correnti e copie originali)
			_.forEach(this.tasklists, tasklist => this.clearSelectionFlags(tasklist.tasks))
			_.forEach(this.tasklistsOriginal, tasklist => this.clearSelectionFlags(tasklist.tasks))
			_.forEach(this.kanbanColumns, column => this.clearSelectionFlags(column.tasks))
			_.forEach(this.kanbanColumnsOriginal, column => this.clearSelectionFlags(column.tasks))
		},

		clearSelectionFlags(tasks) {
			_.forEach(tasks, task => {
				if (task.selected) {
					this.$set(task, 'selected', false)
				}
			})
		},

		onGroupSelectAll(tasks) {
			if (!tasks || !tasks.length) return
			if (!this.selectsMode) {
				this.selectsMode = true
			}
			const allSelected = tasks.every(t => t.selected)
			_.forEach(tasks, task => {
				this.$set(task, 'selected', !allSelected)
			})
		},

		duplicate() {
			Vue.delete(this.model, 'id')
			this.storeTask()
		},

		filterTasks() {
			if (!this.searchQuery || this.searchQuery.trim() === '') {
				// Ripristina la vista originale se non c'è ricerca
				if (this.viewMode === 'tasklist') {
					this.tasklists = _.cloneDeep(this.tasklistsOriginal)
				} else {
					this.kanbanColumns = _.cloneDeep(this.kanbanColumnsOriginal)
				}
				this.filteredTasksCount = null
			} else {
				// Filtra i task in base alla query
				const query = this.searchQuery.toLowerCase()
				let totalFilteredTasks = 0

				if (this.viewMode === 'tasklist') {
					// Clona le tasklist originali e filtra i task
					this.tasklists = this.tasklistsOriginal.map(tasklist => {
						const filteredTasks = tasklist.tasks.filter(task => {
							return this.taskMatchesQuery(task, query)
						})

						totalFilteredTasks += filteredTasks.length

						return {
							...tasklist,
							tasks: filteredTasks
						}
					})
				} else {
					// Filtra le colonne Kanban
					this.kanbanColumns = this.kanbanColumnsOriginal.map(column => {
						const filteredTasks = column.tasks.filter(task => {
							return this.taskMatchesQuery(task, query)
						})

						totalFilteredTasks += filteredTasks.length

						return {
							...column,
							tasks: filteredTasks
						}
					})
				}

				this.filteredTasksCount = totalFilteredTasks
			}
		},

		taskMatchesQuery(task, query) {
			// Cerca nel titolo e nella descrizione del task
			const matchTitle = task.title && task.title.toLowerCase().includes(query)
			const matchDescription = task.description && task.description.toLowerCase().includes(query)
			const matchCode = task.code && task.code.toLowerCase().includes(query)
			const matchAssignee = task.user && task.user.name && task.user.name.toLowerCase().includes(query)
			// Cerca anche nel creator
			const matchCreator = task.creator && task.creator.toLowerCase().includes(query)

			return matchTitle || matchDescription || matchCode || matchAssignee || matchCreator
		},

		initializeTaskboard(showLoader = true) {
			Vue.set(this.taskboardDef, 'filterStatus', this.filterStatus)
			Vue.set(this.taskboardDef, 'filterUserId', this.filterUserId)
			this.tasksSelected = []
			if (showLoader) this.loading = true
			this.axios.post('taskboard/', this.taskboardDef).then(response => {
				// get body data
				this.tasklists = response.data.taskboard
				// Salva una copia originale per il ripristino dopo la ricerca
				this.tasklistsOriginal = _.cloneDeep(response.data.taskboard)
				// Aggiorna la lista utenti per il filtro
				if (response.data.users) {
					this.usersFilter = response.data.users
				}

				// Riapplica il filtro di ricerca sui dati appena caricati
				if (this.searchQuery) {
					this.filterTasks()
				}

				// se è presente il query param task_id apre il dialog
				if(this.$route.query.task_id && !this.query_task_opened) {
					// cerco task per id in tasklists, che è un array di tasklist con chiave tasks che è un array di task
					let task = _.find(_.flatMap(this.tasklists, 'tasks'), {id: parseInt(this.$route.query.task_id)})
					if(!task) {
						this.taskShowed = 'dns'
					}
					task = _.find(_.flatMap(this.tasklists, 'tasks'), {id: parseInt(this.$route.query.task_id)})
					if(task) {
						this.$eventBusUtility.$emit('editTask', {
							task: Object.assign({}, task),
							showDialog: true,
						})
						this.query_task_opened = true
					}

				}

			}, response => {
				 // error callback
			}).finally(() => {
				this.loading = false
			})
		},

		refreshActiveView() {
			if (this.viewMode === 'kanban') {
				this.loadKanbanData(false)
			} else {
				this.initializeTaskboard(false)
			}
		},

		deleteTask() {
			this.axios.post('tasks/delete', {ids: this.model.id}).then(response => {
				// get body data
				this.$eventBusUtility.setSnackbar(response, this.$store)
				this.closeDialog()
				this.refreshActiveView()
			}, response => {
				// error callback
			})
		},

		deleteTasks() {
			this.axios.post('tasks/delete', {ids: this.tasksSelected}).then(response => {
				// get body data
				this.$eventBusUtility.setSnackbar(response, this.$store)
				this.refreshActiveView()
				this.tasksSelected = []
			}, response => {
				// error callback
			})
		},


		archiveTasks() {
			this.axios.post('tasks/archive', {ids: this.tasksSelected}).then(response => {
				// get body data
				this.$eventBusUtility.setSnackbar(response, this.$store)
				if (this.viewMode === 'kanban') {
					this.loadKanbanData(false)
				} else {
					this.initializeTaskboard()
				}
				this.tasksSelected = []
			}, response => {
				// error callback
			})
		},

		storeTask() {
			this.loadingTask = true
			this.confirmExit = false
			this.modelForWatcher = _.cloneDeep(this.model)
			
			this.productTaskValidation().then((prod_result) => {
				if (!prod_result) {
					this.loadingTask = false
					return false
				}
			
				this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
					if (!result) {
						this.loadingTask = false
						return false
					}

					if(_.has(this.model, 'id')) {
						this.axios.put('tasks/' + this.model.id, this.model).then(response => {
							this.closeDialog()
							if (this.viewMode === 'kanban') {
								this.loadKanbanData(false)
							} else {
								this.initializeTaskboard()
							}
						},
						response => {

						})
					} else {
						this.axios.post('tasks/', this.model).then(response => {
							this.closeDialog()
							if (this.viewMode === 'kanban') {
								this.loadKanbanData(false)
							} else {
								this.initializeTaskboard()
							}
						},
						response => {

						})
					}
				}).catch(() => {

				})
			})
		},

		productTaskValidation() {
			if(this.$store.getters.checkSettings('products_association_task')) {
				return this.$refs.productstask.$validator.validateAll()
			} else {
				return new Promise((resolve, reject) => {
					resolve(true)
				})
			}
		},

		closeDialog() {
			if(JSON.stringify(this.model) !== JSON.stringify(this.modelForWatcher) ){
                this.confirmExit = true
			} else {
				this.showDialog = false
				this.fullScreen = false
				this.loadingTask = false
				this.model = _.stubObject()
				this.modelForWatcher = _.stubObject()
				Object.assign(this.model, this.defaultTask)
				this.$store.commit('setModelEdited', false)
			}
		},

		onDrag(event, entity) {
			let data = {
				id: null,
				prev_id: null,
				entity: entity,
				type: 'order',
				listable_type: this.listableType,
			}

			if (entity === 'tasklists') {
				if (event.newIndex === 0) {
					data.id = this.tasklists[event.newIndex].id
				} else {
					data.id = this.tasklists[event.newIndex].id
					data.prev_id = this.tasklists[event.newIndex - 1].id
				}
			} else if (entity === 'tasks') {
				data.id = parseInt(event.clone.id)

				// take all task in current tasklist
				let children = event.to.childNodes

				// search index of task and after take precedent id
				let index = _.findIndex(children, function (value) {
					return parseInt(value.id) === data.id
				})
				if (index > 0) {
					data.prev_id = parseInt(children[index - 1].id)
				} // else is the first
				//data.from_tasklist_id = parseInt(event.from.offsetParent.id)
				data.to_tasklist_id = parseInt(event.to.offsetParent.id)
			}
			this.axios.post(data.entity + 'order/', data).then(response => {
				this.initializeTaskboard(false)
			}, response => {
				this.initializeTaskboard(false)
			})
		},

		pusherConnect() {
			if(this.$echo) {
				this.$echo.private('taskboard.' + this.listableType + '_' + this.listableId + '.' + this.$store.getters.uuid)
				.listen('.TaskUpdated', (e) => {
					if (this.viewMode === 'tasklist') {
						this.initializeTaskboard(false)
					} else {
						this.loadKanbanData(false)
					}
				})
			}
		},

		pusherUnconnect() {
			if(this.$echo) {
				this.$echo.leave('taskboard.' + this.listableType + '_' + this.listableId + '.' + this.$store.getters.uuid)
			}
		},

		// Kanban methods
		async loadKanbanData(showLoader = true) {
			if (showLoader) this.loadingKanban = true
			try {
				const response = await this.axios.post('taskboard-kanban/', {
					listable_type: this.listableType,
					listable_id: this.listableId,
					filterArchived: this.filterStatus,
					filterUserId: this.filterUserId
				})

				if (response.data) {
					this.kanbanColumns = response.data.columns || []
					// Salva una copia originale per il ripristino dopo la ricerca
					this.kanbanColumnsOriginal = _.cloneDeep(this.kanbanColumns)
					this.usersFilter = response.data.users || []
					this.kanbanTasklists = response.data.tasklists || []
					// Riapplica il filtro di ricerca sui dati appena caricati
					if (this.searchQuery) {
						this.filterTasks()
					}
				}
			} catch (error) {
				this.$eventBusUtility.$emit('errorHandler', error)
			} finally {
				if (showLoader) this.loadingKanban = false
			}
		},

		onTasksUpdated({ status, tasks }) {
			// Sincronizza i task locali con i dati del parent
			const columnIndex = this.kanbanColumns.findIndex(col => col.status === status)
			if (columnIndex > -1) {
				this.$set(this.kanbanColumns[columnIndex], 'tasks', tasks)
			}
		},

		async onStatusChanged({ taskId, newStatus, task }) {
			// L'update ottimistico è già gestito da vuedraggable, ma solo la colonna di
			// destinazione emette tasks-updated: il task va rimosso dalle altre colonne
			this.kanbanColumns.forEach(col => {
				if (col.status !== newStatus) {
					const index = col.tasks.findIndex(t => t.id === taskId)
					if (index > -1) {
						col.tasks.splice(index, 1)
					}
				}
			})
			// Facciamo solo la chiamata API per persistere il cambiamento
			try {
				await this.axios.put(`tasks/${taskId}/status`, {
					status: newStatus
				})

				// Aggiorna anche i dati originali per il filtro
				this.kanbanColumnsOriginal = _.cloneDeep(this.kanbanColumns)

				// Mostra notifica di successo
				this.$eventBusUtility.setSnackbar({
					data: { message: 'Stato task aggiornato' }
				}, this.$store)
			} catch (error) {
				this.$eventBusUtility.$emit('errorHandler', error)
				// Rollback: ricarica i dati dal server
				this.loadKanbanData()
			}
		},

		onUserFilterChange() {
			// il filtro di ricerca viene riapplicato dentro le callback di caricamento
			if (this.viewMode === 'kanban') {
				this.loadKanbanData()
			} else {
				this.initializeTaskboard()
			}
		},

		onTaskAdded(task) {
			// Aggiunge il task alla colonna corretta
			const columnIndex = this.kanbanColumns.findIndex(col => col.status === task.status)
			if (columnIndex > -1) {
				this.kanbanColumns[columnIndex].tasks.push(task)
				// Aggiorna anche i dati originali
				this.kanbanColumnsOriginal = _.cloneDeep(this.kanbanColumns)
			}
		}

	},

	created() {

		this.axios.get('tasks-info/').then(response => {
			// get body data
			this.infoData = response.data

			let i = 0
			_.forEach(response.data.fields.fields, f => {
				if(this.listableType == 'user' && f.key == 'users') {
					return
				}
				if (f.key != 'entity' && f.key != 'tasklist_id') {
					Vue.set(this.fieldsset.fields, i, f)
					i++
				}
				if(f.default) {
					Vue.set(this.model, f.key, f.default)
				}
			})
			Object.assign(this.defaultTask, this.model)
			this.$store.commit('endProgress')

			this.initializeTaskboard()
		}, response => {
			// error callback
		})
	},

	mounted() {
		document.addEventListener('keydown', this.handleShortcut)

		this.$eventBusUtility.$on('addTask', payload => {
			this.model['tasklist_id'] = payload.tasklist_id
			this.showDialog = payload.showDialog
			// clone model
			this.modelForWatcher = _.cloneDeep(this.model)
		})

		this.$eventBusUtility.$on('editTask', payload => {
			this.model = payload.task
			this.showDialog = payload.showDialog
			// clone model
			this.modelForWatcher = _.cloneDeep(this.model)
		})		

		this.$eventBusUtility.$on('initializeTaskboard', () => {
			this.initializeTaskboard(false)
		})

		this.$eventBusUtility.$on('onDrag', payload => {
			this.onDrag(payload.event, payload.entity)
		})

		this.$eventBusUtility.$on('selectTask', id => {
			if(id && !this.tasksSelected.includes(id))
				this.tasksSelected.push(id)
		})
		this.$eventBusUtility.$on('unSelectTask', id => {
			if(id)
				this.tasksSelected = this.tasksSelected.filter((val) => {return val != id})
		})

		this.pusherConnect()
	},

	beforeDestroy() {
		this.$eventBusUtility.$off('addTask')
		this.$eventBusUtility.$off('editTask')
		this.$eventBusUtility.$off('initializeTaskboard')
		this.$eventBusUtility.$off('onDrag')
		this.$eventBusUtility.$off('selectTask')
		this.$eventBusUtility.$off('unSelectTask')
		this.pusherUnconnect()
	},
}
</script>
<style>
    .taskboard-wrapper {
		height: calc(100vh - 130px);
		width: 100%;
    }

	.taskboard-wrapper .v-toolbar {
		flex: 0 0 auto;
	}

	.taskboard-content-wrapper {
	    position: relative;
        flex: 1 1 0%;
        box-sizing: border-box;
	}

	.taskboard-content-wrapper .taskboard-content {
	    position: absolute;
	    top: 0;
	    right: 0;
	    bottom: 0;
	    left: 0;
	    height: 100%;
	    overflow-y: hidden;
	    overflow-x: auto;
	    -webkit-overflow-scrolling: touch;
	}


    .taskboard-chosen-tasklist {
        background: transparent;
	}

	/* .taskboard-chosen-tasklist-class {
		height: max-content;
	} */

    #task-hover.v-list-item--link:hover {
        background: transparent !important;
    }    

    #task-hover.v-list-item--link {
        height: 68px !important;
    }

	.v-input__append-outer {
		margin-top: auto !important;
    	margin-bottom: auto !important;
	}
	.checklist-items {
		padding-top: 2px;
		padding-bottom: 2px;
		padding-left: 16px;
		padding-right: 16px;
	}
	.checklist-items .v-input--hide-details, .v-input__prepend-inner {
		margin-top: 0 !important;
		padding: 0px !important;
	}
	.checklist-items .v-input__prepend-inner {
		margin: auto !important;
	}
	/* .checklist-items .v-text-field {
		border: 1px solid #E0E0E0;
		border-radius: 4px;
	}
	.checklist-items .v-text-field:hover {
		border: 1px solid #757575;
		border-radius: 4px;
		box-sizing: border-box;
	} */

	.checklist-items .v-text-field.v-text-field--solo .v-input__control  {
		min-height: 36px !important;
	}
	.checklist-name {
		width: 100%;
	}
	.checklist-name .v-text-field--.v-text-field--single-line input {
		margin-top: 0px !important;
	}
	.checklist-name .v-input__slot {
		padding: 0px !important;
	}

</style>
